export const jobModuleCodes = {
	iFollowThisEducationNow: 762,
	iWorkHereNow: 763,
	allowUseDataForOtherJobsMessage: 903,
	countAndStatus: 1263,
	plural: 1397,
	whatSearchJobTip: 4108,
	recentVacancies: 4118,
	apply: 4173,
	employmentType: 4199,
	allJobs: 4206,
	whatSearchPlaceHolder: 4207,
	whereSearchPlaceHolder: 4208,
	salary: 4211,
	findJobsTileTitle1: 4212,
	findJobsTileTitle2: 4213,
	whatSearchTip: 4214,
	whereSearchTip: 4215,
	workingPeriod: 4219,
	locationArea: 4231,
	industries: 4245,
	similarJobs: 4261,
	topJob: 4265,
	seeAllJobs: 4267,
	cities: 4268,
	howItWorks: 4269,
	addYourCV: 4270,
	pleaseAttachYourCV: 4271,
	ourRecruiterWillFindJobsForYou: 4272,
	yourDreamJob: 4273,
	invitedToInterview: 4274,
	matching: 4276,
	findJobs: 4279,
	categories: 4310,
	daysAgo: 4314,
	primarySkills: 4317,
	expiredJob: 4342,
	workingHoursPerWeek: 4322,
	jobContactTitle: 4349,
	form1SubscriptionTip: 4351,
	approvalLabel: 6068,
	privacyStatement: 6069,
	applyOn: 9386,
	submitApplication: 9387,
	viewAllJobs: 9388,
	yourMotivation: 9397,
	educationLevel: 9437,
	educationName: 9438,
	startEndDateEducation: 9439,
	jobFunction: 9440,
	employerName: 9441,
	experienceLevel: 9442,
	motivation: 9447,
	startEndDateJobFunction: 9461,
	performance: 9495,
	location: 9512,
	myOffice: 12312,
	publishedDate: 14444,
	applyForJob: 14485,
	applicationSubmitted: 14733,
	salaryOrPurchaseRateType: 16285,
	salaryOrPurchaseRateRange: 16286,
	jobTypeForRegularCandidate: 16287,
};
